import React from 'react';
import { createRoot } from 'react-dom/client';
import Modal from 'modal-react-native-web';

import { App } from './App';

import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
const el = document.getElementById('root');
Modal.setAppElement(el);

// React 19 migration: Using createRoot instead of deprecated ReactDOM.render
const root = createRoot(el!);
root.render(<App />);

export default root;
